import { useEffect } from 'react'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/checkout/success')({
  validateSearch: (search: Record<string, unknown>): { session_id?: string } => ({
    session_id: (search.session_id as string) || undefined,
  }),
  head: () => ({
    meta: [{ title: 'Checkout Success | Unbreakable' }],
  }),
  component: CheckoutSuccessRedirect,
})

function CheckoutSuccessRedirect() {
  const { session_id: sessionId } = Route.useSearch()

  useEffect(() => {
    const qs = sessionId ? `?session_id=${encodeURIComponent(sessionId)}` : ''
    window.location.replace(`https://unbreakableapp.com/checkout/success${qs}`)
  }, [sessionId])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-gray-600">Redirecting to checkout success…</p>
    </div>
  )
}
